// extracted by mini-css-extract-plugin
export default {"btn":"btn___bz4KF","video":"video___NC8X5","center_m":"center_m___xUltU"};